import z from "zod";

export const qmsBookingProperties = {
  panelNumber: "panelNumber",
  panelName: "panelName",
  bookingCode: "bookingCode",
  campaignCode: "campaignCode",
  campaignName: "campaignName",
  client: "client",
  agency: "agency",
  bookingType: "bookingType",
  auditor: "auditor",
  salesRep: "salesRep",
  slotsBooked: "slotsBooked",
  bookingStartDate: "bookingStartDate",
  bookingEndDate: "bookingEndDate",
  digital: "digital",
};

export const qmsBookingSchema = z.object({
  panelNumber: z.string(),
  panelName: z.string(),
  bookingCode: z.string(),
  campaignCode: z.string(),
  campaignName: z.string(),
  client: z.string(),
  agency: z.string(),
  bookingType: z.string(),
  auditor: z.string(),
  salesRep: z.string(),
  slotsBooked: z.string(),
  bookingStartDate: z.string(),
  bookingEndDate: z.string(),
  digital: z.string(),
});

export type QmsBooking = z.infer<typeof qmsBookingSchema>;
